export default "__VITE_ASSET__CpVYbz1l__"